import { Typography } from "@suraasa/placebo-ui"
import CpatTourOnboardingMainImage from "assets/Cpat/Tour/main.webp"
import { useSuraasaPlusContext } from "features/SuraasaPlus/context"
import { useEffect } from "react"
import Joyride, { Step } from "react-joyride"
import { BROWSER_STORAGE_KEYS } from "utils/constants"
import { sleep } from "utils/helpers"
import { preloadImages } from "utils/preloadImages"

import { SpnyTourEnum, useSuraasaPlusNewYear } from "../Context"
import { tourManager } from "../TourManager"
import { useTourContext } from "../TourProvider"
import { CPAT_TOUR_TARGETS } from "./constants"
import OnboardingStep from "./OnboardingStep"
import ResumeImpactCpatDashboardTour from "./ResumeImpactCpatDashboardTour"

const CpatTour = () => {
  const { isSPNYUser } = useSuraasaPlusContext()
  const { spnyCpatDashboardTour, isSpnyPlatformIntroCompleted } =
    useSuraasaPlusNewYear()
  const { step, setStep } = useTourContext()

  useEffect(() => {
    if (!isSPNYUser) return

    if (!spnyCpatDashboardTour && isSpnyPlatformIntroCompleted) {
      ;(async () => {
        await preloadImages([CpatTourOnboardingMainImage])
        await sleep(250)
      })()
      const timeoutId = setTimeout(() => {
        setStep("joyride")
        tourManager.initiated(BROWSER_STORAGE_KEYS.spnyCpatDashboardTour)
      }, 500)

      return () => clearTimeout(timeoutId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSpnyPlatformIntroCompleted, spnyCpatDashboardTour, setStep])

  const onComplete = () => {
    setStep(null)
    tourManager.completed(BROWSER_STORAGE_KEYS.spnyCpatDashboardTour)
  }

  const steps: Step[] = [
    {
      target: `.${CPAT_TOUR_TARGETS.reports}`,
      content: (
        <div>
          <div className="p-2.5">
            <Typography variant="title3" className="mb-1 text-start">
              My Reports
            </Typography>
            <Typography
              variant="smallBody"
              className="text-start text-onSurface-600"
            >
              Your CPAT reports will appear as soon as they are ready.
            </Typography>
          </div>
        </div>
      ),
      disableBeacon: true,
    },
    {
      target: `.${CPAT_TOUR_TARGETS.assessmentAvailable}`,
      content: (
        <div>
          <div className="p-2.5">
            <Typography variant="title3" className="mb-1 text-start">
              Start the Assessment Here
            </Typography>
            <Typography
              variant="smallBody"
              className="text-start text-onSurface-600"
            >
              Start your assessment here anytime. Take a quick look at how to
              attempt CPAT.
            </Typography>
          </div>
        </div>
      ),
      disableBeacon: true,
    },
  ]

  const handleJoyrideCallback = data => {
    const { status, lifecycle } = data

    const tourCompletedStatuses = ["finished"]
    if (tourCompletedStatuses.includes(status) && lifecycle === "complete") {
      onComplete()
    }
  }
  if (!isSPNYUser || spnyCpatDashboardTour === SpnyTourEnum.completed)
    return null

  return (
    <>
      <Joyride
        steps={steps}
        run={step === "joyride"}
        tooltipComponent={props => (
          <OnboardingStep toolTipRenderProps={props} onComplete={onComplete} />
        )}
        continuous
        disableOverlayClose
        disableScrolling
        disableCloseOnEsc
        hideBackButton
        hideCloseButton
        callback={handleJoyrideCallback}
      />

      <ResumeImpactCpatDashboardTour />
    </>
  )
}

export default CpatTour
